/** Read the optional, owner-scoped navigation reference from an Apollo error. */
export function getDuplicateSubmissionId(error: unknown): string | null {
  if (!error || typeof error !== 'object' || !('graphQLErrors' in error)) return null;
  if (!Array.isArray(error.graphQLErrors)) return null;
  const duplicate = error.graphQLErrors.find((entry) => entry?.message === 'duplicate_submission');
  const id: unknown = duplicate?.extensions?.existingSubmissionId;
  return typeof id === 'string' && /^[a-z0-9_-]{1,100}$/i.test(id) && !/^\d+$/.test(id)
    ? id
    : null;
}
